import {
  Body1Stronger,
  Button,
  Card,
  CardHeader,
  Tag,
} from '@fluentui/react-components';
import { ArrowRightRegular } from '@fluentui/react-icons';
import { debounce } from 'lodash-es';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { Flex } from '@tdp/common/fluentV9MigrationComponents';
import { useSelector } from '@tdp/core';
import {
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  analyticsV2ContainerStyles,
  LoadingState,
  EmptyState,
  appDetailsSlice,
  analyticsV2MetricsSlice,
  analyticsWidgetsSlice,
} from '@tdp/modules/apps';

export interface IAnalyticsWidgetContainer {
  status: AnalyticsV2WidgetLoadingState;
  size: AnalyticsV2WidgetSize;
  header: string;
  children: React.ReactNode;
  onViewDetails?: () => void;
  isNew?: boolean;
}

export const AnalyticsContainer: React.FC<IAnalyticsWidgetContainer> = ({
  status,
  size,
  header,
  children,
  onViewDetails,
  isNew,
}) => {
  const styles = analyticsV2ContainerStyles();
  const intl = useIntl();

  const dispatch = useDispatch();
  const { appId } = useParams();
  const app = useSelector((s) =>
    appDetailsSlice.selectors.getAppById(s, appId ?? '')
  );

  const onclick = () => {
    // dispatch(ResetAppAnalyticsV2());
    dispatch(analyticsV2MetricsSlice.actions.resetMetricsData());
    dispatch(analyticsWidgetsSlice.actions.resetWidgets());
  };

  useEffect(() => {
    // TODO: (astripa) Add AnalyticsV2WidgetLoaded BI logging
    // if (app && app.teamsAppId) {
    // Logger.LogUserBi(TelemetryObjectId.AnalyticsV2WidgetLoaded, {
    //   appId: app.teamsAppId,
    //   message: header
    // })
    // }
  }, [app]);

  // Add 2 Second debounce to avoid multiple logs for the same widget
  const markWidgetInteraction = debounce(() => {
    // TODO: (astripa) Add AnalyticsV2WidgetInteraction logging
    // if (app && app.teamsAppId) {
    // Logger.LogUserBi(TelemetryObjectId.AnalyticsV2WidgetInteraction, {
    //   appId: app.teamsAppId,
    //   message: header
    // })
    // }
  }, 2000);

  const containerSize =
    size === AnalyticsV2WidgetSize.Small
      ? styles.smallSize
      : size === AnalyticsV2WidgetSize.Medium
        ? styles.mediumSize
        : styles.largeSize;

  let cardContent;
  switch (status) {
    case AnalyticsV2WidgetLoadingState.Error:
      cardContent = <EmptyState failed onClick={onclick} />;
      break;
    case AnalyticsV2WidgetLoadingState.Loaded:
      cardContent = children;
      break;
    default:
      return (
        <Card className={containerSize}>
          <LoadingState />
        </Card>
      );
  }

  return (
    <Card className={containerSize} onPointerEnter={markWidgetInteraction}>
      <Flex fill style={{ padding: '10px' }} gap="gap.medium" column>
        <CardHeader
          header={
            <Body1Stronger>
              {
                <Flex gap="gap.medium" vAlign="center" fill>
                  <Body1Stronger>{header}</Body1Stronger>
                  {isNew && (
                    <Tag appearance="brand" style={{ padding: '6px' }}>
                      {intl.formatMessage({
                        defaultMessage: 'new',
                        description: 'new widget tag',
                      })}
                    </Tag>
                  )}
                </Flex>
              }
            </Body1Stronger>
          }
        />
        {cardContent}
        {onViewDetails && (
          <Flex>
            <Button
              appearance="transparent"
              className={styles.viewDetailsButton}
              onClick={onViewDetails}
            >
              {intl.formatMessage({
                defaultMessage: 'View details ',
                description: 'Teams Store validation',
              })}
              {<ArrowRightRegular className={styles.viewDetailsButtonIcon} />}
            </Button>
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
